/* @flow */
import type { Action } from "../action";

export type Fault = {
  endpoint: string,
  options?: {
    method?: string,
    body?: string | FormData
    // TODO: Нужно больше полей!
  },
  message: string,
  response?: Object
};

type State = {
  isVisible: boolean,
  faults: Array<Fault>
};

const initialState = {
  isVisible: false,
  faults: []
};

function serverFaults(state: State = initialState, action: Action): State {
  switch (action.type) {
    case "RECORD_SERVER_FAULT":
      return {
        isVisible: action.payload.isVisible,
        faults: [...state.faults, action.payload.fault]
      };
    case "DISMISS_SERVER_FAULT":
      return {
        ...state,
        isVisible: false
      };
    default:
      return state;
  }
}

export default serverFaults;

export function getErrorMessage(state: State): string | null {
  if (!state.isVisible || state.faults.length === 0) {
    return null;
  }

  return state.faults[state.faults.length - 1].message;
}



// WEBPACK FOOTER //
// ./src/redux/reducer/serverFaults.js